import type { ComponentType } from "react";
import CourseAttachedView from "./views/CourseAttachedView";
import VideoVariantAttachedView from "./views/VideoVariantAttachedView";
import AcademyVariantAttachedView from "./views/AcademyVariantAttachedView";
import AttachCourseModalAdapter from "./adapters/AttachCourseModalAdapter";
import AttachServiceModalAdapter from "./adapters/AttachServiceModalAdapter";

export type ModuleConnector = {
  id: number;
  type: "ONE_TO_ONE" | "ONE_TO_MANY" | "MANY_TO_MANY";
  coreModelName: string;
  nicheModelName: string;
  connectionLabel: string;
  industryId: number;
};

export type NicheViewProps = {
  child: any;
  connector: ModuleConnector;
};

export type NicheModalProps = {
  open: boolean;
  onClose: () => void;
  /** The deal being attached to — null in create mode (see `createForLead`). */
  child: any;
  connector: ModuleConnector;
  /**
   * Set when the lead has NO deal yet (deals only on attach): the modal
   * CREATES the lead's first deal with the picked item instead of patching an
   * existing one. `child` is null then.
   */
  createForLead?: { id: number; name?: string | null } | null;
};

export type NicheEntry = {
  AttachedView: ComponentType<NicheViewProps>;
  AttachModal: ComponentType<NicheModalProps>;
  /** Optional override label for the attach CTA. Falls back to connector.connectionLabel. */
  attachLabel?: string;
};

/**
 * The ONE place niches are mapped to UI for the Overview "Active Child Attachments" block.
 * Adding a new industry's niche = add one line here.
 *
 * Niches not present in this registry render NOTHING in Overview (silent skip),
 * which keeps things safe for industries that haven't been wired up yet.
 */
export const NICHE_REGISTRY: Record<string, NicheEntry> = {
  course: {
    AttachedView: CourseAttachedView,
    AttachModal: AttachCourseModalAdapter,
    attachLabel: "Course",
  },
  videoServiceVarients: {
    AttachedView: VideoVariantAttachedView,
    AttachModal: AttachServiceModalAdapter,
    attachLabel: "Service Variant",
  },
  academyProgramVariant: {
    AttachedView: AcademyVariantAttachedView,
    AttachModal: AttachServiceModalAdapter,
    attachLabel: "Program Variant",
  },
};

export function getNicheEntry(nicheModelName: string): NicheEntry | undefined {
  return NICHE_REGISTRY[nicheModelName];
}
